import { useCallback } from 'react';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
import { getNotTrackingInfo, RentReportingNotTrackingAction } from '../utils';
import { showRentReportingManageModal } from '../components/RentReportingManageModal';
import { isWeb } from '../../../constants';
const useNotTrackingCTAPress = (options) => {
    const navigation = useMainStackNavigation();
    const fromFeed = !!options?.fromFeed;
    return useCallback((data) => {
        if (isWeb) {
            UnavailableOnWebModal.show('emma://rent-reporting', 'Manage rent reporting');
            return;
        }
        const info = getNotTrackingInfo(data);
        if (info.mergeWithManageButton && !fromFeed) {
            showRentReportingManageModal(data);
            return;
        }
        if (info.action === RentReportingNotTrackingAction.BROKEN_CONNECTIONS) {
            navigation.navigate('BrokenConnections');
        }
        else if (info.action === RentReportingNotTrackingAction.LOGINS_RECONSENT) {
            navigation.navigate('LoginsReconsent', { isModal: true });
        }
        else {
            navigation.navigateDeprecated('RentReporting');
        }
    }, [navigation, fromFeed]);
};
export default useNotTrackingCTAPress;
